import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/About.css';

const About = () => {
  return (
    <div className="apple-page apple-about">
      <header className="apple-page-hero">
        <p className="apple-eyebrow">About</p>
        <h1 className="apple-display">미라이쥬쿠</h1>
        <p className="apple-lede">
          일본 대학 입시 요강과 전형을 한국어로 정리하는 정보 사이트입니다.
        </p>
      </header>

      <div className="apple-about-body">
        <p>
          한일 국비유학으로 홋카이도대학 정보이공학을 전공하고, 일반입시로 삿포로의과대학에
          합격한 경험을 바탕으로 박민준이 운영합니다.
        </p>
        <p>
          강의 판매보다, EJU·일반입시·국비·종합형 루트를 이해하고 모집요항을 비교할 수 있는
          가이드와 도구에 집중합니다. 필요한 경우 90분 루트 컨설팅이나 연간 시즌패스를
          신청할 수 있습니다.
        </p>
      </div>

      <div className="apple-about-profile">
        <img src="/images/instructor-profile-front.png" alt="박민준" />
        <div>
          <h2>박민준</h2>
          <p className="role">운영 · 입시 루트 해설</p>
          <ul>
            <li>세종과학고등학교</li>
            <li>홋카이도대학 정보이공학</li>
            <li>삿포로의과대학 의학과</li>
          </ul>
          <a
            className="apple-about-naver"
            href="https://search.naver.com/search.naver?where=nexearch&sm=tab_etc&mra=bjky&pkid=1&os=37389535&qvt=0&query=%EB%B0%95%EB%AF%BC%EC%A4%80"
            target="_blank"
            rel="noopener noreferrer"
          >
            네이버 인물
          </a>
        </div>
      </div>

      <div className="apple-about-note">
        <h2>참고</h2>
        <p>
          사이트 정보는 참고용입니다. 지원 자격·시험 과목·일정은 반드시 각 대학의
          최신 모집요항 원문으로 확인하세요.
        </p>
      </div>

      <div className="apple-page-foot apple-about-cta">
        <Link to="/consulting" className="apple-btn apple-btn-primary">
          컨설팅 신청
        </Link>
        <Link to="/pass" className="apple-link">
          시즌패스
        </Link>
        <Link to="/finder" className="apple-link">
          루트 찾기
        </Link>
      </div>
    </div>
  );
};

export default About;
